import { translate as i18n } from "@/i18n";import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { firebaseErrorMessage, getFirebaseServices } from "@/lib/firebase";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/common";
import PageLoading from "@/components/PageLoading";
import { MailCheck, LogOut } from "lucide-react";
import { toast } from "sonner";

function VerifyGate() {
  const { user, logout, refreshUser } = useApp();
  const [sending, setSending] = useState(false);
  const isHotmailEmail = /@hotmail\.[^@]+$/i.test(user?.email?.trim() || "");
  const resend = async () => {
    setSending(true);
    try {
      const { auth, authApi } = await getFirebaseServices();
      if (!auth.currentUser) throw new Error("missing-firebase-user");
      await authApi.sendEmailVerification(auth.currentUser, { url: `${window.location.origin}/verificar` });
      toast.success(i18n("ui.components_appgate.email_de_verificacion_enviado"));
    } catch (error) {toast.error(firebaseErrorMessage(error, i18n("ui.components_appgate.verificationSendFailed")));}
    setSending(false);
  };
  return (
    <div className="min-h-screen brand-grad flex flex-col" data-testid="verify-gate">
      <header className="max-w-3xl w-full mx-auto px-5 h-16 flex items-center"><Logo /></header>
      <div className="flex-1 flex items-center justify-center px-5 pb-16">
        <div className="w-full max-w-md bg-white rounded-3xl border border-slate-200 soft-shadow p-8 text-center">
          <div className="w-16 h-16 rounded-2xl bg-amber-50 flex items-center justify-center mx-auto mb-4"><MailCheck className="w-8 h-8 text-amber-500" /></div>
          <h1 className="font-head text-2xl font-semibold text-slate-900">{i18n("ui.components_appgate.confirma_tu_correo")}</h1>
          <p className="text-slate-500 mt-2">{i18n("ui.components_appgate.verificationSent", { email: user?.email })}</p>
          {isHotmailEmail && <p className="mt-3 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-700" data-testid="hotmail-spam-notice">{i18n("ui.components_appgate.hotmailSpamNotice")}</p>}
          <div className="flex flex-col gap-3 mt-7">
            <Button onClick={resend} disabled={sending} data-testid="resend-verify-gate" className="rounded-xl h-11 bg-[#0F4C5C] hover:bg-[#0c3f4c]">{sending ? i18n("ui.components_appgate.enviando") : i18n("ui.components_appgate.reenviar_email_de_verificacion")}</Button>
            <Button variant="outline" onClick={() => refreshUser()} data-testid="verify-refresh" className="rounded-xl h-11">{i18n("ui.components_appgate.ya_lo_he_confirmado")}</Button>
            <button onClick={logout} data-testid="verify-logout" className="text-sm text-slate-400 hover:text-slate-600 mt-1 inline-flex items-center gap-1 justify-center"><LogOut className="w-3.5 h-3.5" />{i18n("ui.components_appgate.cerrar_sesion")}</button>
          </div>
        </div>
      </div>
    </div>);

}

export default function AppGate({ children }) {
  const { user, loading } = useApp();
  if (loading) return <PageLoading label={i18n("ui.components_appgate.cargando")} />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.emailVerified) return <VerifyGate />;
  return children;
}
